import { createImageUrlBuilder } from '@sanity/image-url'

import { dataset, projectId } from '../env'

// https://www.sanity.io/docs/image-url
const builder = createImageUrlBuilder({ projectId, dataset })

// Канонический unwrap licensedImage-обёртки (миграция оставила обложки как
// licensedImage{image}). Раньше это выражение было инлайн-скопировано ~12 раз.
// Для urlFor вызывать НЕ нужно — он разворачивает сам; нужен, когда image
// используется напрямую (проверка .asset, alt, <Image src>).
export const unwrapImage = (x) => (x?._type === 'licensedImage' ? x.image : x)

export const urlFor = (source) => {
  // Нормализация источника: миграция оставила обложки как licensedImage[] / licensedImage.
  // Приводим к реальному image-asset, чтобы @sanity/image-url не падал ("Unable to resolve image URL").
  let src = source
  if (Array.isArray(src)) src = src[0]
  if (src && src._type === 'licensedImage' && src.image) src = src.image
  return builder.image(src).quality(75).auto('format')
}

// Безопасно строит crop-URL hero/cover ЛЮБОЙ формы (image, licensedImage, их массивы),
// возвращает undefined для пустого источника вместо исключения. Закрывает класс багов
// `unwrapImage(x)?.asset` — unwrapImage НЕ разворачивает массивы, а hero/cover хранятся
// как массив, из-за чего .asset был undefined и фото подменялось заглушкой.
export const resolveImageUrl = (source, width = 1920, height = 1080) => {
  const first = Array.isArray(source) ? source[0] : source
  if (!first) return undefined
  try {
    return urlFor(source).width(width).height(height).fit('crop').url()
  } catch {
    return undefined
  }
}

// Responsive card sources: the browser chooses the smallest sufficient Sanity
// CDN variant for the rendered tile and device pixel ratio. This keeps ordinary
// screens light while giving large/Retina bento tiles enough source pixels.
export const resolveImageSrcSet = (source, widths = [480, 760, 1200], ratio = 760 / 480) => {
  if (!source) return undefined
  try {
    return widths
      .map((width) => `${urlFor(source).width(width).height(Math.round(width / ratio)).fit('crop').url()} ${width}w`)
      .join(', ')
  } catch {
    return undefined
  }
}
